import { render } from "./CompanyView.vue?vue&type=template&id=f8bca58c&scoped=true&ts=true&lang=pug"
import script from "./CompanyView.vue?vue&type=script&lang=ts"
export * from "./CompanyView.vue?vue&type=script&lang=ts"

import "./CompanyView.vue?vue&type=style&index=0&id=f8bca58c&lang=scss&scoped=true"

import exportComponent from "/Users/danielwu/Documents/bearathome/bat-project/bat-org-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8bca58c"]])

export default __exports__